export default "__VITE_ASSET__aUKbxx$$__"